module.exports = __webpack_public_path__ + "e4d847fa4c92bee1fa1189c431e093e8.jpg";